import { Spacer } from '@sparemin/blockhead';
import * as React from 'react';

import Button from 'components/Button';
import { H1 } from 'components/Heading';
import { CaptionsCircle } from 'components/icons';
import { ProjectTypeByAssets, TranscriptStatus } from 'utils/constants';

import { block } from '../../../utils';
import TranscriptAddCaptionsMessage from './TranscriptAddCaptionsMessage';
import TranscriptInProgressDisplay from './TranscriptInProgressDisplay';
import { CaptionsNotSetMessageType } from './types';

interface IProps {
  hasMedia: boolean;
  projectTypeByAssets: ProjectTypeByAssets;
  status: TranscriptStatus;
  onClickAddAudio: () => void;
  onClickAddVideo: () => void;
  onClickCaptionUpload: () => void;
}

export default class TranscriptStatusDisplay extends React.PureComponent<
  IProps
> {
  private renderTranscriptMessage = (
    captionsMessageType: CaptionsNotSetMessageType,
  ) => {
    const { onClickCaptionUpload } = this.props;

    let Content = null;

    switch (captionsMessageType) {
      case 'media-available':
        Content = 'Select a caption source to get started:';
        break;
      case 'media-not-available':
      default:
        Content = (
          <TranscriptAddCaptionsMessage
            onClickCaptionUpload={onClickCaptionUpload}
          />
        );
        break;
    }

    return <span className={block('transcript-message')}>{Content}</span>;
  };

  private renderTranscriptActions = (
    captionsMessageType: CaptionsNotSetMessageType,
  ) => {
    const { onClickAddAudio, onClickAddVideo } = this.props;

    if (captionsMessageType !== 'media-available') {
      return null;
    }

    return (
      <Spacer
        className={block('transcript-actions')}
        orientation="vertical"
        space={1}
      >
        <Button
          size="medium"
          theme="submit"
          onClick={onClickAddAudio}
          className={block('button')}
          fluid
          data-test="add-audio-button"
        >
          Add audio
        </Button>
        <div>or</div>
        <Button
          size="medium"
          theme="submit"
          onClick={onClickAddVideo}
          className={block('button')}
          fluid
          data-test="add-video-button"
        >
          Add video
        </Button>
      </Spacer>
    );
  };

  private getCaptionsMessageType = (): CaptionsNotSetMessageType => {
    const { hasMedia } = this.props;

    if (!hasMedia) {
      return 'media-available';
    }

    return 'media-not-available';
  };

  public render() {
    const { status } = this.props;
    const {
      getCaptionsMessageType,
      renderTranscriptMessage,
      renderTranscriptActions,
    } = this;

    switch (status) {
      case TranscriptStatus.TRANSCRIPT_STATUS_AVAILABLE:
        return null;

      case TranscriptStatus.TRANSCRIPT_STATUS_IN_PROGESS:
        return <TranscriptInProgressDisplay />;

      default:
        return (
          <div className={block('generate-caption')}>
            <div className={block('transcript', { na: true })}>
              <CaptionsCircle className={block('transcript-icon')} />
              <H1>Add captions</H1>

              {renderTranscriptMessage(getCaptionsMessageType())}

              {renderTranscriptActions(getCaptionsMessageType())}
            </div>
          </div>
        );
    }
  }
}

export { IProps as TranscriptStatusDisplayProps };
